// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-more-menu-dialog {
  margin: -10px -20px;
}
.fi-more-menu-dialog > a {
  display: block;
  padding: 10px;
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./Source/app/utilities/more-menu-mobile/more-menu-mobile.component.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;AACJ;AACI;EACI,cAAA;EACA,aAAA;EACA,qBAAA;AACR","sourcesContent":[".fi-more-menu-dialog {\r\n    margin: -10px -20px;\r\n\r\n    > a {\r\n        display: block;\r\n        padding: 10px;\r\n        text-decoration: none;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
